import { Env } from "../../../env";
import { ModalRecommendJsEnv } from "../../../models/add_cart/modal_recommend_js_env";
import { isSoloare } from "../../../models/js_env";
import { RootContainer } from "../../../root_container";
import { applyCarouselStyle } from "../../common/carousel_util";
import { RecommendModal } from "./modal_recommend_body";

export class ModalRecommendContainer extends RootContainer<ModalRecommendJsEnv> {
  constructor(model: ModalRecommendJsEnv) {
    super();

    if (isSoloare(Env.SITE_TYPE)) {
      this.mount(RecommendModal, model.rrAreaProfileItemModal.placementName);
      this.update(model);

      const placementNameList = [model.rrAreaProfileItemModal.placementName];

      const carouselIdList = placementNameList.map(placementName => placementName + "-carousel");
      applyCarouselStyle(carouselIdList);
    }
  }
}